import { AxiosInstance } from 'axios';
import { ServiceOptionsRepository } from '@/model/repository/manager/serviceOptions/ServiceOptionsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ServiceOptionsRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
